import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { RETAILERS_QUERY } from "graphql/retailers";

const getBearerToken = () => {
  try {
    return localStorage.getItem("accessToken") || "";
  } catch {
    return "";
  }
};

let retailersClient = null;

const getRetailersClient = () => {
  if (retailersClient) {
    return retailersClient;
  }

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_DOORSHARP_GRAPHQL_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "Content-Type": "application/json",
      ...(getBearerToken() ? { Authorization: `Bearer ${getBearerToken()}` } : {}),
    },
  }));

  retailersClient = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    },
  });

  return retailersClient;
};

export async function fetchRetailers(timePeriod = "YTD", highlightsTimePeriod = "YTD") {
  try {
    const client = getRetailersClient();

    const { data } = await client.query({
      query: RETAILERS_QUERY,
      variables: { timePeriod, highlightsTimePeriod },
      fetchPolicy: "network-only",
    });

    console.log("Retailers GraphQL response:", data);
    return data;
  } catch (error) {
    console.error("Retailers GraphQL error:", error);
    throw error;
  }
}

